import React from 'react';
import Loadable from 'react-loadable';
import Loader from '../../utils/Loader';
import AuthenticatedLayout from '../Layouts/Authenticated';

const DataResidency = Loadable({
    loader: () => import('./residency' /* webpackChunkName: "Data-residency" */),
    loading() {
        return <Loader />;
    },
});

export const DataResidencyComponent = (props: any) => (
    <AuthenticatedLayout>
        <DataResidency {...props} />
    </AuthenticatedLayout>
);
